"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _style = _interopRequireDefault(require("./style.css"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning2"));
var _Mediator = _interopRequireDefault(require("../../../navigations/withModules/Mediator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Fortress = window.cccisd.fortress;
var languageMapper = {
  en: 'English',
  es: 'Spanish'
};
var Preview = function Preview(_ref) {
  var assignmentData = _ref.assignmentData,
    closeModal = _ref.closeModal,
    formikBag = _ref.formikBag;
  var buildLanguages = (0, _get2["default"])(assignmentData, 'settings.buildLanguages', []);
  var _useState = (0, _react.useState)(buildLanguages[0]),
    _useState2 = _slicedToArray(_useState, 2),
    language = _useState2[0],
    setLanguage = _useState2[1];

  // use localProgress to persist progress even after switching languages
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    localProgress = _useState4[0],
    setLocalProgress = _useState4[1];
  var currPrefix = (0, _get2["default"])(formikBag, 'values.currentPrefix', '');

  // deep clone so the Mediator does not edit Fromik state directly
  var modules = (0, _cloneDeep2["default"])((0, _get2["default"])(formikBag, "values.".concat(currPrefix, ".modules"), []) || []);
  var surveyModuleMap = modules.reduce(function (map, module) {
    if (!Array.isArray(module.surveyHandles) || !module.id) {
      return map;
    }
    module.surveyHandles.forEach(function (surveyHandle, lessonIndex) {
      if (!map[surveyHandle]) {
        map[surveyHandle] = {};
      }
      map[surveyHandle][module.id] = lessonIndex + 1;
    });
    return map;
  }, {});
  function processFlowList() {
    var allFlows = [];
    var surveys = (0, _get2["default"])(assignmentData, 'currentSurveylistList.surveyList', []) || [];
    surveys.forEach(function (surv) {
      var flows = (0, _get2["default"])(surv, 'flowList', []) || [];
      var moduleIds = [];
      if (surveyModuleMap[surv.surveyHandle]) {
        moduleIds = Object.keys(surveyModuleMap[surv.surveyHandle]);
      }
      flows.forEach(function (f) {
        if (f.language !== language) {
          return;
        }
        moduleIds.forEach(function (moduleId) {
          var _surv$settings, _surv$settings2, _surv$settings3;
          allFlows.push(_objectSpread(_objectSpread(_objectSpread({}, f), {}, {
            flowSettings: f.settings,
            handle: f.flowHandle,
            isComplete: (0, _get2["default"])(localProgress, "".concat(language, ".").concat(f.flowHandle)),
            isPreviewMode: true,
            isRequired: !!(surv !== null && surv !== void 0 && (_surv$settings = surv.settings) !== null && _surv$settings !== void 0 && _surv$settings.isRequired),
            isStarted: f.flowHandle in ((0, _get2["default"])(localProgress, language, {}) || {}),
            moduleId: parseInt(moduleId, 10),
            ordinalPosition: surveyModuleMap[surv.surveyHandle][moduleId],
            pawnHash: Fortress.user.acting.random_hash,
            pawnId: Fortress.user.acting.id,
            showIfOption: [f.flowHandle],
            surveySettings: surv.settings
          }, surv !== null && surv !== void 0 && (_surv$settings2 = surv.settings) !== null && _surv$settings2 !== void 0 && _surv$settings2.quickReview ? {
            quickReview: surv.settings.quickReview
          } : {}), surv !== null && surv !== void 0 && (_surv$settings3 = surv.settings) !== null && _surv$settings3 !== void 0 && _surv$settings3.quickReviewTitle ? {
            quickReviewTitle: surv.settings.quickReviewTitle
          } : {}));
        });
      });
    });
    return allFlows;
  }
  function processMediatorProps() {
    // clone deep so Mediator does not modify Formik state directly
    var mediatorProps = (0, _cloneDeep2["default"])((0, _get2["default"])(formikBag, "values.".concat(currPrefix)));
    mediatorProps.modules = mediatorProps.modules.map(function (mod) {
      mod.language = language;
      if (language === 'en' && 'headerEn' in mod) {
        mod.header = mod.headerEn;
      }
      if (language === 'en' && 'titleEn' in mod) {
        mod.title = mod.titleEn;
      }
      if (language === 'en' && 'iconEn' in mod) {
        mod.icon = mod.iconEn;
      }
      if (language === 'es' && 'headerEs' in mod) {
        mod.header = mod.headerEs;
      }
      if (language === 'es' && 'titleEs' in mod) {
        mod.title = mod.titleEs;
      }
      if (language === 'es' && 'iconEs' in mod) {
        mod.icon = mod.iconEs;
      }
      delete mod.headerEn;
      delete mod.headerEs;
      delete mod.titleEn;
      delete mod.titleEs;
      delete mod.iconEn;
      delete mod.iconEs;
      return mod;
    });
    return mediatorProps;
  }
  function handleFlowComplete(_ref2) {
    var flowHandle = _ref2.flowHandle;
    setLocalProgress(function (prev) {
      if (!prev[language]) {
        prev[language] = {};
      }
      prev[language][flowHandle] = true;
      return prev;
    });
  }
  function handleFlowStart(_ref3) {
    var flowHandle = _ref3.flowHandle;
    setLocalProgress(function (prev) {
      if (!prev[language]) {
        prev[language] = {};
      }
      if (!prev[language][flowHandle]) {
        prev[language][flowHandle] = false;
      }
      return prev;
    });
  }
  var mediatorProps = processMediatorProps();
  var isVisibilityByEntity = false;
  try {
    isVisibilityByEntity = Object.keys(mediatorProps.pinnedContent).some(function (moduleId) {
      if (moduleId === 'topLevel') {
        return mediatorProps.pinnedContent.topLevel.some(function (pc) {
          return pc.unlockAfter === 'entity';
        });
      }
      return Object.keys(mediatorProps.pinnedContent[moduleId]).some(function (lessonHandle) {
        return mediatorProps.pinnedContent[moduleId][lessonHandle].some(function (pc) {
          return pc.unlockAfter === 'entity';
        });
      });
    }) || mediatorProps.modules.some(function (m) {
      return ['hidden', 'disabled'].includes(m.visibility) && m.unlockAfter === 'entity';
    });
  } catch (e) {
    // meh
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].body
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].preview
  }, !Array.isArray(modules) || modules.length <= 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-info",
    role: "alert"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-info"
  }, "You must create modules to see a Preview.")) : /*#__PURE__*/_react["default"].createElement(_Mediator["default"], {
    key: language,
    allowRetake: true,
    flowList: processFlowList(),
    isNetworkError: false,
    isPreviewMode: true,
    language: language,
    mediatorProps: mediatorProps,
    onComplete: function onComplete() {},
    onAssignmenComplete: function onAssignmenComplete() {},
    onModuleComplete: function onModuleComplete() {},
    onFlowComplete: handleFlowComplete,
    onFlowStarted: handleFlowStart
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonRow
  }, buildLanguages.length > 1 && /*#__PURE__*/_react["default"].createElement("ul", {
    className: 'nav nav-pills ' + _style["default"].langPills
  }, buildLanguages.map(function (lang) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      role: "presentation",
      key: lang,
      className: "nav-item"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        setLanguage(lang);
      },
      className: 'nav-link ' + (language === lang ? 'active' : '')
    }, languageMapper[lang]));
  })), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: closeModal,
    type: "button",
    className: "btn btn-secondary"
  }, "Close Preview"), isVisibilityByEntity && /*#__PURE__*/_react["default"].createElement("p", {
    className: _style["default"].unlockLogicWarning
  }, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
    spaceRight: true
  }), "The unlocking logic for Pinned Content or Modules that is based on a specific part of a lesson will not work in Preview mode.")));
};
var _default = exports["default"] = Preview;